import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

import styles from './Grid.module.scss'

export const Row = ({ children, className, bottomIndent = false, topIndent = false, bottomIndentLarge = false }) => (
  <div
    className={classNames(styles.gridRow, className, {
      [styles.withBottomIndent]: bottomIndent,
      [styles.bottomIndentLarge]: bottomIndentLarge,
      [styles.withTopIndent]: topIndent,
    })}>
    {children}
  </div>
)

Row.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  bottomIndent: PropTypes.bool,
  bottomIndentLarge: PropTypes.bool,
  topIndent: PropTypes.bool,
}
